/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_Soil_MoistureInputs */

const vi_irrigation_sensor_soil_moisture = /** @type {(inputs: Irrigation_Sensor_Soil_MoistureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Độ ẩm`)
};

/**

* @param {Irrigation_Sensor_Soil_MoistureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_soil_moisture = /** @type {((inputs?: Irrigation_Sensor_Soil_MoistureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_Soil_MoistureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_soil_moisture(inputs)
});